import { render, staticRenderFns } from "./qx.vue?vue&type=template&id=2c68351e&"
import script from "./qx.vue?vue&type=script&lang=js&"
export * from "./qx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports